import { createContext } from "react";

export const BidContext = createContext();